import React from "react"
import { Box } from "@mui/material"
import PropTypes from "prop-types"
import EmissionTable from "../../components/data-emission-table/emission-table"

const EmissionsTab = ({ data, loading, isAdminUser }) => (
    <Box sx={{ width: "100%", p: 3, boxSizing: "border-box" }}>
        <EmissionTable data={data} loading={loading} isAdminUser={isAdminUser} />
    </Box>
)

EmissionsTab.propTypes = { data: PropTypes.array, loading: PropTypes.bool, isAdminUser: PropTypes.bool }

export default EmissionsTab
